import type { DashboardStatsShape } from "./FinancialMetrics";
import { CollectionProgress as SharedCollectionProgress } from "@/components/dashboard";

type CollectionProgressProps = {
  stats: DashboardStatsShape;
  collectionPercentage: number;
};

const CollectionProgress = ({ stats, collectionPercentage }: CollectionProgressProps) => (
  <SharedCollectionProgress
    collectionPercentage={collectionPercentage}
    amounts={[
      {
        label: "Received",
        amount: stats.paymentsReceived || 0,
        color: "success.main",
      },
      {
        label: "Pending",
        amount: stats.paymentsPending || 0,
        color: "error.main",
      },
    ]}
  />
);

export default CollectionProgress;
